import React from 'react';
import { BaseFilterProps, DropDownFilter } from 'framework/list';
import { EnumDropdown } from 'framework/form';
import { KPI_STATUS_OPTIONS } from '../../useKPIService';

const KpiStatusFilter = ({ ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props}>
      <EnumDropdown options={KPI_STATUS_OPTIONS} {...props} />
    </DropDownFilter>
  );
};

export default KpiStatusFilter;
